import Screen from 'ui/layouts/Screen';
import type { ScreenProps } from 'ui/layouts/Screen';
import FinanceComponent, { FinanceProvider } from 'ui/organizms/Finance';

const Finance = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Finance'
    >
        <FinanceProvider>
            <FinanceComponent />
        </FinanceProvider>
    </Screen>
);

export default Finance;
